import { useParams, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'

// Game components
import { Baccarat } from '@/features/games/baccarat'
import { Blackjack } from '@/features/games/blackjack'
import { Ruleta } from '@/features/games/ruleta'
import { BlackjackMultiplayer } from '@/features/games/blackjack-multiplayer'
import { Slots } from '@/features/games/slots'

export default function Game() {
  const { gameId } = useParams()
  const navigate = useNavigate()

  const renderGame = () => {
    switch (gameId) {
      case 'ruleta':
        return <Ruleta />
      case 'blackjack':
        return <Blackjack />
      case 'baccarat':
        return <Baccarat />
      case 'blackjack-multiplayer':
        return (
          <BlackjackMultiplayer
            onPlaySolo={() => navigate('/game/blackjack')}
            onExit={() => navigate('/lobby')}
          />
        )
      case 'slots':
        return <Slots />
      default:
        return (
          <div className="flex-1 flex items-center justify-center">
            <div className="text-center">
              <p className="text-gray-400 mb-4">Juego no encontrado</p>
              <Button variant="gold" onClick={() => navigate('/lobby')}>
                Volver al Lobby
              </Button>
            </div>
          </div>
        )
    }
  }

  return (
    <div className="flex-1 flex flex-col">
      {renderGame()}
    </div>
  )
}
